module.exports = __webpack_public_path__ + "static/media/6.af75f332.gif";